webpackJsonp([259337086591876],{

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _particles = __webpack_require__(57);
	
	var _particles2 = _interopRequireDefault(_particles);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroSmall = function HeroSmall(_ref) {
	  var title = _ref.title,
	      desc = _ref.desc,
	      name = _ref.name;
	  return _react2.default.createElement(
	    'div',
	    { className: 'hero-area-small' },
	    _react2.default.createElement(_particles2.default, null),
	    _react2.default.createElement(
	      _container2.default,
	      { customClassName: 'hero-area-container' },
	      _react2.default.createElement(
	        'p',
	        { className: 'static-project-name' },
	        name
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        desc
	      )
	    )
	  );
	};
	
	exports.default = HeroSmall;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _heroSmallProject = __webpack_require__(77);
	
	var _heroSmallProject2 = _interopRequireDefault(_heroSmallProject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Coinis = function Coinis(props) {
	  return _react2.default.createElement(
	    "main",
	    null,
	    _react2.default.createElement(_heroSmallProject2.default, {
	      name: "Adwe.com",
	      title: "RTB Platform",
	      desc: "Managing a self-coded Real-Time-Bidding Platform which operates with all ad formats for both mobile and desktop users, handling over 5B daily requests globally. "
	    }),
	    _react2.default.createElement(
	      _container2.default,
	      { customClassName: "project-padding" },
	      _react2.default.createElement("img", { src: "/static/adwe-logo.png", className: "project-logo", alt: "adwe.com" }),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Established in 2015, Adwe is an OpenRTB platform powered and driven by strong engines that accumulate and recommend the best content for website visitors. By combining such tech with the right amount of passionate digital advertising mavens and prolific engineers, Adwe managed to position itself among the best content recommendation platforms worldwide."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Though they are bathing now in success, the background story was as thorny as a plethora of rose bushes. The urge to develop such platform came after its founders met and discussed the Internet\u2019s need for a properly vetted system which delivers content based on real-time preferences - excluding all unwanted articles while prolonging the visitors on line journey with even more interesting content."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Though mainly focused on engaging users on websites and apps, Adwe also strained to create the right chemistry between advertisers and top-tier publishers while providing both parties with access to state-of-the-art predictive technology that will skyrocket their ROI. They make sure that ads appear on the right places, while taking utmost care about user-experience, fraud detection as well as their elimination."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Thousands of customers of all sizes speak volumes about Adwe\u2019s efforts in the advertising industry, and every single one of them would either recommend it for advertising or monetization purposes. Most certainly one of the biggest brand catalysts among seach and social for campaign advocacy."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "More at: ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://adwe.com", target: "_blank" },
	          "adwe.com"
	        )
	      )
	    )
	  );
	};
	
	exports.default = Coinis;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-project-adwe-js-3a98c2052db75b7efe4e.js